<template>
  <admin-wrapper :straight-title="additionalModuleName" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers scope="water" class="pt-8" schema_scope="water" :tab-prop="tab" />
    </template>
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'WaterSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    payload: {},
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules.WATER_DATA.verbose_name'),
    moduleEnabler() {
      return {
        name: 'water_data_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
